import React, { useEffect } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Link } from 'react-router-dom';
import { Check, ArrowRight, Home, TreePine, Wrench, Truck, FileText, Car, Building, Phone } from 'lucide-react';
import { Button } from './ui/button';

// Configuration complète des tarifs par service
const tarifs = [
  {
    id: 'menage',
    name: 'Ménage à domicile',
    icon: Home,
    hasTaxCredit: true,
    pricing: [
      { type: 'Ménage ponctuel', price: 'À partir de 30€/heure', afterCredit: '15€/heure' },
      { type: 'Ménage régulier', price: '25€/heure', afterCredit: '12,50€/heure' },
      { type: 'Nettoyage en profondeur', price: 'Sur devis', afterCredit: '-50%' },
      { type: 'Nettoyage des vitres', price: 'Sur devis', afterCredit: '-50%' }
    ],
    note: 'Réservation minimum 2 heures. Tarif dégressif selon la fréquence des interventions.'
  },
  {
    id: 'jardinage',
    name: 'Jardinage',
    icon: TreePine,
    hasTaxCredit: true,
    pricing: [
      { type: 'Tonte de pelouse', price: 'Sur devis', afterCredit: '-50%' },
      { type: 'Taille de haies', price: 'Sur devis', afterCredit: '-50%' },
      { type: 'Désherbage', price: 'Sur devis', afterCredit: '-50%' },
      { type: 'Ramassage des feuilles', price: 'Sur devis', afterCredit: '-50%' },
      { type: 'Petit élagage', price: 'Sur devis', afterCredit: '-50%' }
    ],
    note: 'Devis personnalisé selon la superficie et l\'état du jardin'
  },
  {
    id: 'bricolage',
    name: 'Bricolage',
    icon: Wrench,
    hasTaxCredit: true,
    pricing: [
      { type: 'Montage de meubles', price: '30€/heure', afterCredit: '15€/heure' },
      { type: 'Pose de tringles', price: '30€/heure', afterCredit: '15€/heure' },
      { type: 'Fixation étagères', price: '30€/heure', afterCredit: '15€/heure' },
      { type: 'Petites réparations', price: '30€/heure', afterCredit: '15€/heure' },
      { type: 'Peinture', price: 'Sur devis', afterCredit: '-50%' }
    ],
    note: 'Prix hors fournitures. Besoin d\'aide ? Nous achetons le matériel nécessaire pour vous avant notre intervention.'
  },
  {
    id: 'demenagement',
    name: 'Aide au déménagement',
    icon: Truck,
    hasTaxCredit: false,
    pricing: [
      { type: 'Aide cartons', price: 'Dès 35€/h', afterCredit: null },
      { type: 'Aide chargement/déchargement', price: 'Dès 35€/h', afterCredit: null }
    ],
    note: 'Nos tarifs n\'incluent pas le transport de meubles lourds (pianos, coffres, etc.). Le prix final sera ajusté selon le volume et la distance kilométrique entre vos deux adresses.'
  },
  {
    id: 'administratif',
    name: 'Aide administrative',
    icon: FileText,
    hasTaxCredit: true,
    pricing: [
      { type: 'Tri et classement', price: '25€/heure', afterCredit: '12,50€/heure' },
      { type: 'Démarches en ligne', price: '25€/heure', afterCredit: '12,50€/heure' },
      { type: 'Rédaction de courriers', price: '25€/heure', afterCredit: '12,50€/heure' }
    ],
    note: 'Accompagnement personnalisé à domicile'
  },
  {
    id: 'vehicule',
    name: 'Nettoyage de véhicule',
    icon: Car,
    hasTaxCredit: false,
    isVehicleTable: true,
    vehiclePricing: [
      { category: 'Petit véhicule (mini, 2 places)', interieur: '60€', exterieur: '40€', complet: '100€' },
      { category: 'Véhicule standard', interieur: '70€', exterieur: '50€', complet: '120€' },
      { category: 'Gros véhicule (4x4, 7 places, camionnette)', interieur: '90€', exterieur: '60€', complet: '150€' }
    ],
    extraPricing: [
      { type: 'Désodorisation', price: 'Sur devis' },
      { type: 'Traitement cuir', price: 'Sur devis' }
    ],
    note: 'Intervention à domicile ou à déposer à l\'agence'
  },
  {
    id: 'airbnb',
    name: 'Gestion Airbnb',
    icon: Building,
    hasTaxCredit: false,
    pricing: [
      { type: 'Ménage entre locations', price: 'Sur devis', afterCredit: null },
      { type: 'Check-in / Check-out', price: 'Sur devis', afterCredit: null },
      { type: 'Gestion du linge', price: 'Sur devis', afterCredit: null },
      { type: 'Courses', price: 'Sur devis', afterCredit: null },
      { type: 'Jardinage', price: 'Sur devis', afterCredit: null }
    ],
    note: 'Tarification adaptée selon le nombre de biens et la fréquence'
  }
];

export const TarifsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-[#153254] to-[#122b26]">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-white mb-6">
              Nos Tarifs
            </h1>
            <p className="text-xl text-white/80 mb-8">
              Des prix transparents pour tous nos services à domicile
            </p>
            <div className="inline-flex items-center gap-3 bg-[#D4AF37]/20 backdrop-blur-sm px-6 py-3 rounded-xl">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-[#D4AF37] rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl md:text-2xl">-50%</span>
              </div>
              <span className="text-white font-medium">
                Crédit d'impôt immédiat sur les services éligibles
              </span>
            </div>
          </div>
        </div>
      </section>
      
      {/* Tarifs Grid */}
      <section className="py-16 bg-[#F4F7F6]">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto space-y-8">
            {tarifs.map((service) => {
              const IconComponent = service.icon;
              return (
                <div 
                  key={service.id} 
                  id={`tarif-${service.id}`}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden scroll-mt-24"
                >
                  {/* Service Header */}
                  <div className="bg-[#153254] px-6 py-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center">
                        <IconComponent className="h-6 w-6 text-white" />
                      </div>
                      <h2 className="text-xl md:text-2xl font-bold text-white">
                        {service.name}
                      </h2>
                    </div>
                    {service.hasTaxCredit && (
                      <div className="flex items-center gap-2 bg-[#D4AF37]/20 px-4 py-2 rounded-lg self-start sm:self-auto">
                        <Check className="h-4 w-4 text-[#D4AF37]" />
                        <span className="text-white text-sm font-medium">Éligible crédit d'impôt 50%</span>
                      </div>
                    )}
                  </div>
                  
                  {/* Pricing Table */}
                  <div className="p-4 md:p-6">
                    {/* Special vehicle pricing table */}
                    {service.isVehicleTable ? (
                      <>
                        <div className="overflow-x-auto">
                          <table className="w-full min-w-[400px]">
                            <thead>
                              <tr className="border-b border-gray-200">
                                <th className="text-left py-3 px-3 md:px-4 text-[#153254] font-semibold text-sm md:text-base">Type de véhicule</th>
                                <th className="text-center py-3 px-3 md:px-4 text-[#153254] font-semibold text-sm md:text-base">Intérieur</th>
                                <th className="text-center py-3 px-3 md:px-4 text-[#153254] font-semibold text-sm md:text-base">Extérieur</th>
                                <th className="text-center py-3 px-3 md:px-4 text-[#D4AF37] font-semibold text-sm md:text-base">Complet</th>
                              </tr>
                            </thead>
                            <tbody>
                              {service.vehiclePricing.map((item, index) => (
                                <tr key={index} className="border-b border-gray-100 last:border-0">
                                  <td className="py-3 md:py-4 px-3 md:px-4 text-gray-700 text-sm md:text-base">{item.category}</td>
                                  <td className="py-3 md:py-4 px-3 md:px-4 text-center font-medium text-[#153254] text-sm md:text-base">{item.interieur}</td>
                                  <td className="py-3 md:py-4 px-3 md:px-4 text-center font-medium text-[#153254] text-sm md:text-base">{item.exterieur}</td>
                                  <td className="py-3 md:py-4 px-3 md:px-4 text-center font-semibold text-[#D4AF37] text-sm md:text-base">{item.complet}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        {/* Extra services */}
                        {service.extraPricing && (
                          <div className="mt-4 pt-4 border-t border-gray-200">
                            <p className="text-sm font-medium text-[#153254] mb-2 px-4">Options supplémentaires :</p>
                            <div className="flex flex-wrap gap-4 px-4">
                              {service.extraPricing.map((item, index) => (
                                <span key={index} className="text-sm text-gray-600">
                                  {item.type} : <span className="font-medium">{item.price}</span>
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      /* Standard pricing table */
                      <div className="overflow-x-auto">
                        <table className="w-full min-w-[320px]">
                          <thead>
                            <tr className="border-b border-gray-200">
                              <th className="text-left py-3 px-3 md:px-4 text-[#153254] font-semibold text-sm md:text-base">Prestation</th>
                              <th className="text-right py-3 px-3 md:px-4 text-[#153254] font-semibold text-sm md:text-base">Tarif</th>
                              {service.hasTaxCredit && (
                                <th className="text-right py-3 px-3 md:px-4 text-[#D4AF37] font-semibold text-sm md:text-base">Après crédit</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {service.pricing && service.pricing.map((item, index) => (
                              <tr key={index} className="border-b border-gray-100 last:border-0">
                                <td className="py-3 md:py-4 px-3 md:px-4 text-gray-700 text-sm md:text-base">{item.type}</td>
                                <td className="py-3 md:py-4 px-3 md:px-4 text-right font-medium text-[#153254] text-sm md:text-base">{item.price}</td>
                                {service.hasTaxCredit && (
                                  <td className="py-3 md:py-4 px-3 md:px-4 text-right font-semibold text-[#D4AF37] text-sm md:text-base">
                                    {item.afterCredit}
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    
                    {/* Note */}
                    {service.note && (
                      <p className="mt-4 text-sm text-gray-500 italic px-4">
                        * {service.note}
                      </p>
                    )}
                    
                    {/* CTA */}
                    <div className="mt-6 flex flex-col sm:flex-row gap-3 px-4">
                      <Link to={`/devis-premium?service=${service.id}`}>
                        <Button className="bg-[#D4AF37] hover:bg-[#c9a030] text-white font-medium w-full sm:w-auto">
                          Demander un devis
                          <ArrowRight className="ml-2 h-4 w-4" />
                        </Button>
                      </Link>
                      <Link to={`/service/${service.id}`}>
                        <Button variant="outline" className="border-[#153254] text-[#153254] hover:bg-[#153254] hover:text-white w-full sm:w-auto">
                          En savoir plus
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      
      {/* CTA Final */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#153254] mb-6">
              Une question sur nos tarifs ?
            </h2>
            <p className="text-gray-600 mb-8 text-lg">
              Contactez-nous pour un devis personnalisé adapté à vos besoins
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/devis-premium">
                <Button size="lg" className="bg-[#D4AF37] hover:bg-[#c9a030] text-white font-semibold px-8 py-6">
                  Demander un devis gratuit
                </Button>
              </Link>
              <a href="tel:0981543842">
                <Button size="lg" variant="outline" className="border-2 border-[#153254] text-[#153254] hover:bg-[#153254] hover:text-white px-8 py-6">
                  <Phone className="mr-2 h-5 w-5" />
                  09 81 54 38 42
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};
